export default __webpack_public_path__ + "static/media/coin.b61670d2.svg";